// extracted by css-extract-rspack-plugin
export default {"fixedLayout":"bOS4AwrxPMYJ9whs"};